import { CalendarFormBuilderState } from '../../params/redux/calendar_form_builder';
import { createSlice } from '@reduxjs/toolkit';

// Initial state with default values for authentication and user info
const initialState: CalendarFormBuilderState = {
    formTemplates: [],
    formFields: {
        formTemplateId: 2,
        fields: []
    },
    selectedFormField: null,
    loaders: {
        isLoading: false,
        isCreating: false,
        isUpdating: false,
        isDeleting: false,
        isSearching: false,
        isInserting: false
    }
};

// Slice for app-related states and actions
const calendarFormBuilderSlice = createSlice({
    // Slice name
    name: 'calendarFormBuilder',
    // inital state for the slice
    initialState,
    reducers: {
        addFormFieldInCalendarBuilder: (state, action) => {
            state.formFields.fields.push({
                ...action.payload,
                default: false
            });
        },
        duplicateFormFieldInCalendarBuilder: (state, action) => {
            const fieldToDuplicate = state.formFields.fields.find((field) => field.id === action.payload);
            if (fieldToDuplicate) {
                const duplicatedField = {
                    ...fieldToDuplicate,
                    id: `field-${fieldToDuplicate.type}-${Date.now()}`,
                    label: `${fieldToDuplicate.label} (Copy)`
                };
                state.formFields.fields.push(duplicatedField);
            }
        },
        editFormFieldInCalendarBuilder: (state, action) => {
            state.formFields.fields = state.formFields.fields.map((field) => (field.id === state.selectedFormField?.id ? { ...field, ...action.payload } : field));
            state.selectedFormField = { ...state.selectedFormField, ...action.payload };
        },
        removeFormFieldInCalendarBuilder: (state, action) => {
            state.formFields.fields = state.formFields.fields.filter((field) => field.id !== action.payload);
            if (action.payload === state.selectedFormField?.id) {
                state.selectedFormField = null;
            }
        },
        settingFormFieldsInCalendarBuilder: (state, action) => {
            state.formFields = action.payload;
            state.selectedFormField = null;
        },
        settingSelectedCalendarFormFieldProperty: (state, action) => {
            state.selectedFormField = action.payload;
        },
        reorderFormFieldsInCalendarBuilder: (state, action) => {
            const { sourceIndex, destinationIndex } = action.payload;
            if (sourceIndex !== destinationIndex) {
                const updateFields = [...state.formFields.fields];
                const [movedField] = updateFields.splice(sourceIndex, 1);
                updateFields.splice(destinationIndex, 0, movedField);
                state.formFields.fields = updateFields;
            }
        },
        // Resets loading states related to app actions
        resettingCalendarFormBuilderLoader: (state) => {
            state.loaders = initialState.loaders;
        },
        // Resets all app data to the initial state
        resettingCalendarFormBuilderCalendarData: () => initialState
    }
});

// Exporting actions for updating app state
export const {
    addFormFieldInCalendarBuilder,
    duplicateFormFieldInCalendarBuilder,
    editFormFieldInCalendarBuilder,
    removeFormFieldInCalendarBuilder,
    settingFormFieldsInCalendarBuilder,
    settingSelectedCalendarFormFieldProperty,
    reorderFormFieldsInCalendarBuilder,
    resettingCalendarFormBuilderLoader,
    resettingCalendarFormBuilderCalendarData
} = calendarFormBuilderSlice.actions;

// Exporting the reducer to be used in the store
export default calendarFormBuilderSlice.reducer;
